import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const initConfirmation = () => {
  document.querySelectorAll('.confirmation-section').forEach((container) => {
    const button = container.querySelector('.btn--primary');

    if(button) {
      const urlParts = button.getAttribute('href').split('#');
      const target = (urlParts.length > 0) ? document.querySelector('#'+urlParts[1]) : false;

      if(target) {
        button.addEventListener('click', (e) => {
          if(urlParts.length > 0) {
            if(target) {
              e.preventDefault();

              gsap.to(window, {
                duration: 1,
                scrollTo: target
              });
            }
          }
        });

        /*ScrollTrigger.create({
          trigger: target,
          start: 'top top',
          once: true,
          onEnter: () => {
            container.remove();
            gsap.to(window, {
              duration: 0,
              scrollTo: 0
            });
          }
        });*/
      }
    }
  });
};

export { initConfirmation };